import { render, staticRenderFns } from "./SwiperVideoEdit.vue?vue&type=template&id=afcbe3da&scoped=true"
import script from "./SwiperVideoEdit.vue?vue&type=script&lang=js"
export * from "./SwiperVideoEdit.vue?vue&type=script&lang=js"
import style0 from "./SwiperVideoEdit.vue?vue&type=style&index=0&id=afcbe3da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcbe3da",
  null
  
)

export default component.exports